export const partners = [
    {
        name: "Cliniques",
        serviceId: {
            name: "Consultation generaliste"
        }
    },
    {
        name: "Cabinet dentaire",
        serviceId: {
            name: "dentition"
        }
    },
    {
        name: "Cabinet optique",
        serviceId: {
            name: "vision"
        }
    },
    {
        name: "Laboratoire",
        serviceId: {
            name: "prise de sang"
        }
    },
    {
        name: "Pharmacie",
        serviceId: {
            name: "Analyse radio"
        }
    }
]